import Vue from "vue";

Vue.mixin({
  methods: {
    // 封装路由跳转代码 判断是否重复跳转
    jumpFn(url, data = null) {
      if (url === this.$route.path) return;

      if (!data) {
        this.$router.push(url);
      } else {
        this.$router.push({
          path: url,
          query: data,
        });
      }
    },
  },
});
